var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 32 32",
        stroke: _vm.color,
      },
    },
    [
      _c("title", [_vm._v("fullscreen")]),
      _vm._v(" "),
      _c("path", {
        attrs: {
          fill: "none",
          "stroke-linejoin": "round",
          "stroke-linecap": "round",
          "stroke-miterlimit": "4",
          "stroke-width": "2.6667",
          stroke: _vm.color,
          d: "M11.353 6.706h-8.52v5.422",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          fill: "none",
          "stroke-linejoin": "round",
          "stroke-linecap": "round",
          "stroke-miterlimit": "4",
          "stroke-width": "2.6667",
          stroke: _vm.color,
          d: "M20.647 6.706h8.52v5.422",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          fill: "none",
          "stroke-linejoin": "round",
          "stroke-linecap": "round",
          "stroke-miterlimit": "4",
          "stroke-width": "2.6667",
          stroke: _vm.color,
          d: "M20.647 25.294h8.52v-5.422",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          fill: "none",
          "stroke-linejoin": "round",
          "stroke-linecap": "round",
          "stroke-miterlimit": "4",
          "stroke-width": "2.6667",
          stroke: _vm.color,
          d: "M11.353 25.294h-8.52v-5.422",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }